// Checkout API
import { apiClient } from './base';

export const checkoutAPI = {
  // Process checkout
  processCheckout: async (orderData) => {
    try {
      const response = await apiClient.post('/api/orders', orderData);
      return response.data;
    } catch (error) {
      console.error('Error processing checkout:', error);
      throw error;
    }
  },
  
  // Create Stripe payment intent
  createStripePaymentIntent: async (amount, orderId, customerId, customerEmail) => {
    try {
      const response = await apiClient.post('/api/stripe/create-payment-intent', {
        amount,
        orderId,
        customerId,
        customerEmail
      });
      return response.data;
    } catch (error) {
      console.error('Error creating Stripe payment intent:', error);
      throw error;
    }
  },
  
  // Confirm Stripe payment
  confirmStripePayment: async (paymentIntentId) => {
    try {
      const response = await apiClient.post('/api/stripe/confirm-payment', {
        paymentIntentId
      });
      return response.data;
    } catch (error) {
      console.error('Error confirming Stripe payment:', error);
      throw error;
    }
  },
  
  // Get order by ID
  getOrder: async (orderId) => {
    try {
      const response = await apiClient.get(`/api/orders/${orderId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching order:', error);
      throw error;
    }
  },
  
  // Update order status
  updateOrderStatus: async (orderId, status) => {
    try {
      const response = await apiClient.patch(`/api/orders/${orderId}`, { status });
      return response.data;
    } catch (error) {
      console.error('Error updating order status:', error);
      throw error;
    }
  }
};
